<template>
    <!-- 单独查看ppt -->
    <el-dialog
        :visible.sync="dialogVisible"
        width="6.6667rem"
        :before-close="handleClose">
        <div class="div-container">
            <div class="top">
                <div class="title">中小学生生命健康教育平台</div>
                <div class="time"><span >{{type==1?'随笔感悟':'工作简报'}} |  </span>{{ item.createTime }}</div>
            </div>
            <div class="content" id="content">
            </div>
        </div>
    </el-dialog>
</template>
<script>
  export default {
    name:'HealthEducationDetails',
    props:{
        dialogVisible:{
            type: Boolean,
            default: false
        },
        // 文章的title
        type:{
            type: Number,
            default: 1
        },
        item:{
            type:Object,
            default:{}
        }
    },
    watch:{
        item:{
            deep:true,
            immediate:true,
            handler(newVal,oldVal){
                console.log(newVal)
                this.getContent()
            },
        }
    },
    mounted(){
        // this.getContent()
    },
    methods: {
      getContent(){
        this.$nextTick(()=>{
            console.log(11111)
        let content = document.getElementById('content')
        content.innerHTML = this.item.content
        })
        
      },
      handleClose() {
        this.$emit('changeDialogVisible')
      },
      save(){
        this.$emit('changeDialogVisible')
      }
    }
  }
</script>
<style lang="less" scoped>
    /deep/ .el-dialog{
        padding: .1389rem;
        box-sizing: border-box;
        width: 4.75rem !important;
        height: 3.6528rem;
        box-sizing: border-box;

        // justify-content: space-between;
        .el-dialog__header,.el-dialog__body{
            padding: 0rem;
        }
        .el-dialog__body{
            display: flex;
        }
        .div-container{
            .top{
                padding-bottom: .1111rem;
                width: 4.5139rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                border-bottom: 1px solid rgb(199,199,199);
                .title{
                    font-size: .1389rem;
                    font-weight: bold;
                }
                .time{
                    font-size: .0833rem;
                }
            }
            .content{
                width: 4.5139rem;
                // overflow: hidden;
                height:2.7778rem;
                // border: 1px solid red;
                overflow: auto;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/overWord.vue